import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ListaService } from '@app/services/lista.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmacionListasComponent } from '../../tareas/tablero-detalle/modals/confirmacion-listas.component';
import Swal from 'sweetalert2';

interface Tarea {
  id: string;
  titulo: string;
}

interface ListaLocal {
  id: string;
  titulo: string;
  estado: 'Por hacer' | 'En progreso' | 'Hecho';
  orden?: number;
  tareas: Tarea[]; // ✅ requerido por ListaComponent
}

@Component({
  selector: 'app-tablero-detalle',
  templateUrl: './tablero-detalle.component.html',
})
export class TableroDetalleComponent implements OnInit {
  nombreTablero = '';
  descripcionTablero = '';
  tableroId!: number;
  listas: ListaLocal[] = [];

  mostrarFormularioLista = false;
  nuevoTituloLista = '';

  constructor(
    private route: ActivatedRoute,
    private listaService: ListaService,
    private dialog: MatDialog,
    private router: Router
  ) { }

  listasConectadas: string[] = [];
  ngOnInit(): void {

   
    const state = history.state;

    if (state && state.nombre) {
      this.nombreTablero = state.nombre;
      this.descripcionTablero = state.descripcion || '';
      localStorage.setItem('tableroNombre', this.nombreTablero);
      localStorage.setItem('tableroDescripcion', this.descripcionTablero);
      this.tableroId = +this.route.snapshot.paramMap.get('id')!;
      localStorage.setItem('tableroId', this.tableroId.toString());

    } else {
      this.nombreTablero = localStorage.getItem('tableroNombre') || 'Tablero';
      this.descripcionTablero = localStorage.getItem('tableroDescripcion') || '';
    }

    this.tableroId = +this.route.snapshot.paramMap.get('id')!;
    this.obtenerListas();
  }

  verDetalle(tablero: any) {
    localStorage.setItem('tableroNombre', tablero.nombre);
    localStorage.setItem('tableroDescripcion', tablero.descripcion || '');

    this.router.navigate(['/tareas/tablero', tablero.id], {
      state: {
        nombre: tablero.nombre,
        descripcion: tablero.descripcion
      }
    });
  }

obtenerListas(): void {
  Swal.fire({
    title: 'Cargando listas...',
    allowOutsideClick: false,
    didOpen: () => Swal.showLoading()
  });

  this.listaService.listarListasTareasPorTablero(this.tableroId).subscribe({
    next: (res: any) => {
      Swal.close();

      if (res.listas && res.listas.length > 0) {
        this.listas = res.listas.map((l: any) => ({
          id: l.id.toString(),
          titulo: l.nombre,
          estado: l.estado,
          orden: typeof l.orden === 'number' ? l.orden : 0,
          tareas: Array.isArray(l.tareas)
            ? l.tareas.map((t: any) => ({
              id: t.id.toString(),
              titulo: t.titulo,
              descripcion: t.descripcion || '',
              tipo_asignacion: t.tipo_asignacion,
              asignado_a: t.asignado_a,
              fecha_creacion: t.fecha_creacion
            }))
            : []
        })).sort((a: any, b: any) => a.orden - b.orden);

        // ✅ Aquí llenamos las listas conectadas
        this.listasConectadas = this.listas.map((l: any) => l.id);
      } else {
        this.mostrarModalConfirmacion();
      }
    },
    error: (error) => {
      Swal.close();
      console.error('Error al obtener listas:', error);
      Swal.fire('Error', 'No se pudieron cargar las listas con tareas.', 'error');
    }
  });
}


  mostrarModalConfirmacion() {
    const dialogRef = this.dialog.open(ConfirmacionListasComponent);

    dialogRef.afterClosed().subscribe((confirmado: boolean) => {
      if (confirmado) {
        this.crearListasSecuenciales();
      } else {
        this.listas = [];
      }
    });
  }

  async crearListasSecuenciales() {
    const user = JSON.parse(localStorage.getItem('user')!);
    const usuario_id = user?.id;

    const listasBase: Omit<ListaLocal, 'id'>[] = [
      { titulo: 'Por hacer', estado: 'Por hacer', orden: 1, tareas: [] },
      { titulo: 'En progreso', estado: 'En progreso', orden: 2, tareas: [] },
      { titulo: 'Hecho', estado: 'Hecho', orden: 3, tareas: [] }
    ];

    Swal.fire({
      title: 'Estamos preparando tu entorno...',
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading()
    });

    for (const lista of listasBase) {
      await this.listaService.crearLista({
        nombre: lista.titulo,
        estado: lista.estado,
        orden: lista.orden,
        tablero_id: this.tableroId,
        usuario_id: usuario_id
      }).toPromise();
    }

    Swal.close();
    this.obtenerListas();
  }

  abrirModalCrearLista() {
    alert('Abrir modal para agregar lista');
  }

  crearNuevaLista() {
    const user = JSON.parse(localStorage.getItem('user')!);
    const usuario_id = user?.id;

    if (!this.nuevoTituloLista.trim()) {
      Swal.fire('Error', 'El nombre de la lista es obligatorio', 'warning');
      return;
    }

    const nuevaLista = {
      nombre: this.nuevoTituloLista.trim(),
      estado: this.nuevoTituloLista.trim(),
      tablero_id: this.tableroId,
      usuario_id: usuario_id
    };

    Swal.fire({
      title: 'Creando lista...',
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading()
    });

    this.listaService.crearLista(nuevaLista).subscribe({
      next: () => {
        Swal.close();
        Swal.fire('Éxito', 'Lista creada correctamente', 'success');
        this.nuevoTituloLista = '';
        this.mostrarFormularioLista = false;
        this.obtenerListas();
      },
      error: (err) => {
        Swal.close();
        console.error(err);
        Swal.fire('Error', 'No se pudo crear la lista', 'error');
      }
    });
  }

  cancelarNuevaLista() {
    this.nuevoTituloLista = '';
    this.mostrarFormularioLista = false;
  }
}
